import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { companyLogo } from '../data/mock';
import { MapPin, Phone, Mail, Clock, AlertCircle } from 'lucide-react';

const Contact = () => {
  const { t } = useLanguage();

  return (
    <section id="contact" className="py-24 bg-[#1e293b]">
      <div className="container mx-auto px-8">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="heading-2 text-[#60a5fa] mb-4">{t.contact.title}</h2>
            <p className="body-large text-[#94a3b8]">{t.contact.subtitle}</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-[#0f172a] p-8 border border-[#1e40af]">
              <h3 className="heading-5 text-[#60a5fa] mb-6">{t.contact.address}</h3>
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <MapPin className="w-5 h-5 text-[#60a5fa] mt-1 flex-shrink-0" />
                  <div>
                    <p className="body-small text-[#94a3b8]">
                      Terneuzen, Netherlands
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-3">
                  <Phone className="w-5 h-5 text-[#60a5fa] mt-1 flex-shrink-0" />
                  <div>
                    <p className="body-small text-[#94a3b8]">{t.contact.phone}</p>
                  </div>
                </div>

                <div className="flex items-start space-x-3">
                  <Mail className="w-5 h-5 text-[#60a5fa] mt-1 flex-shrink-0" />
                  <div>
                    <p className="body-small text-[#94a3b8]">{t.contact.email}</p>
                  </div>
                </div>

                <div className="flex items-start space-x-3">
                  <Clock className="w-5 h-5 text-[#60a5fa] mt-1 flex-shrink-0" />
                  <div>
                    <p className="body-small text-[#94a3b8]">{t.contact.hours}</p>
                  </div>
                </div>

                <div className="flex items-start space-x-3 pt-4 border-t border-[#1e40af]">
                  <AlertCircle className="w-5 h-5 text-[#60a5fa] mt-1 flex-shrink-0" />
                  <div>
                    <p className="body-small text-[#60a5fa] font-medium">{t.contact.emergency}</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-[#0f172a] p-8 border border-[#1e40af] flex items-center justify-center">
              <img
                src={companyLogo}
                alt="Charter Roofings Logo"
                className="max-w-full h-auto"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
